/**
 * DoctorsReportTable — отчёт по врачам клиники: приёмы, начислено,
 * оплачено, долг, средний чек.
 */

import type {DoctorReportRow} from '@services/reports';
import {Table, TableBody, TableCell, TableHead, TableHeader, TableRow} from '@components/ui/Table';
import {formatNumber} from '@utils/format';

const th = 'text-[11px] font-semibold uppercase tracking-[.04em] text-skr-label';

type Props = {rows: DoctorReportRow[]};

export const DoctorsReportTable = ({rows}: Props) => (
  <div className="overflow-hidden rounded-[15px] border border-skr-line bg-card">
    <div className="border-b border-skr-line2 px-[18px] py-3.5 text-[13.5px] font-semibold">
      По врачам
    </div>
    <div className="overflow-x-auto">
      <Table className="min-w-[760px] text-[13px]">
        <TableHeader>
          <TableRow className="border-b border-skr-line2 bg-skr-head hover:bg-skr-head">
            <TableHead className={th}>Врач</TableHead>
            <TableHead className={`${th} text-right`}>Приёмы</TableHead>
            <TableHead className={`${th} text-right`}>Начислено</TableHead>
            <TableHead className={`${th} text-right`}>Оплачено</TableHead>
            <TableHead className={`${th} text-right`}>Долг</TableHead>
            <TableHead className={`${th} text-right`}>Ср. чек</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map((r) => (
            <TableRow key={r.membershipId} className="border-b border-skr-hairline">
              <TableCell>
                <div className="font-semibold text-foreground">{r.fullName}</div>
                <div className="text-xs text-muted-foreground">{r.specializationName}</div>
              </TableCell>
              <TableCell className="tnum text-right font-mono text-skr-ink">
                {r.completed}
                <span className="text-skr-faint"> / {r.appointments}</span>
              </TableCell>
              <TableCell className="tnum text-right font-mono text-skr-ink">
                {formatNumber(r.charged)}
              </TableCell>
              <TableCell className="tnum text-right font-mono font-medium text-foreground">
                {formatNumber(r.paid)}
              </TableCell>
              <TableCell
                className={`tnum text-right font-mono ${r.debt > 0 ? 'text-skr-warn' : 'text-skr-faint'}`}
              >
                {formatNumber(r.debt)}
              </TableCell>
              <TableCell className="tnum text-right font-mono text-skr-ink">
                {formatNumber(r.averageCheck)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  </div>
);
